import { defineTemplate } from '../../../../utils';
import { PLAYER_VS_PLAYER_LEAGUES } from './leagues';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates/thumbnails`;

export const disneyEspnPlayerVSPlayer = defineTemplate({
  mode: 'legacy',
  id: 'espn/espn-vs/futbol',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Miniatura con jugadores',
  templateFamily: 'espn-vs-miniatura',
  thumbnail: {
    url: `${BASE}/player-vs-player.png`,
    optimizedUrl: `${BASE}/optimized/player-vs-player.png`,

    aspectRatio: 'horizontal'
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'league',
      label: 'Liga',
      type: 'select',
      required: true,
      options: PLAYER_VS_PLAYER_LEAGUES.map(league => ({ value: league.value, label: league.label }))
    },
    // Options populated dynamically by the handler based on previous selections.
    {
      key: 'team1',
      label: 'Equipo 1',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team2']
    },
    {
      key: 'player1',
      label: 'Jugador 1',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['player2']
    },
    {
      key: 'team2',
      label: 'Equipo 2',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team1']
    },
    {
      key: 'player2',
      label: 'Jugador 2',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['player1']
    }
  ],
  promptTemplate: 'Haceme una "miniatura con jugadores" de LaLiga con los jugadores Kylian Mbappé y Julián Álvarez'
});
